import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  root: {
    backgroundColor: ({ color, shade }) => {
      if (theme.palette[color]) {
        return theme.palette[color][shade];
      }

      return color;
    },
    boxSizing: 'border-box',
    borderRadius: 4,
    color: theme.palette.common.white,
    fontSize: ({ size }) => {
      let fontSize = 14;
      switch (size) {
        case 'small':
          fontSize = 10;
          break;
        case 'medium':
          fontSize = 12;
          break;
        default:
          fontSize = 14;
      }
    },
    fontFamily: theme.font.medium,
    fontWeight: '500',
    height: 'auto',
    padding: '2px 5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  icon: {
    height: ({ size }) => {
      let height = 14;
      switch (size) {
        case 'small':
          height = 9;
          break;
        case 'medium':
          height = 11;
          break;
        default:
          height = 14;
      }

      return height;
    },
  },
}));
